"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class CustomReasonApi {
    constructor(api) {
        this.api = api;
    }
    /**
     * 取得自訂取消原因
     */
    getCustomReason() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/customreason';
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    /**
     * 新增自訂取消原因
     */
    createCustomReason(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/customreason';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改自訂取消原因
     */
    updateCustomReason(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/customreason/${id}`;
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    /**
     * 刪除自訂取消原因
     */
    deleteCustomReason(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/customreason/${id}`;
            yield this.api.axiosGo.delete(endpoint);
        });
    }
}
exports.default = CustomReasonApi;
//# sourceMappingURL=CustomReason.js.map